<template>
  <fieldset class="fieldset">
    <slot></slot>
  </fieldset>
</template>

<script>
export default {
  name: "M4Fieldset"
};
</script>

<style scoped></style>
